import { SiteHeader } from "@/components/layout/site-header";
import { SiteFooter } from "@/components/layout/site-footer";
import { ThemeToggle } from "@/components/layout/theme-toggle";
import { Logo } from "@/components/layout/logo";
import { InitiativeRequestForm } from "@/components/auth/initiative-request-form";
import { useAppContext } from "@/providers";
import { useDocumentTitle } from "@/hooks/use-document-title";
import { t } from "@/lib/i18n/messages";

export default function InitiativeRequestPage() {
  const { locale } = useAppContext();
  const isRTL = locale === "ar";
  useDocumentTitle(`${t(locale, "initiativeRequestTitle")} | NCircle`);

  return (
    <div className="min-h-screen flex flex-col bg-muted/40 dark:bg-background">
      <SiteHeader />

      <main className="flex-1 flex items-start justify-center py-12 px-4 pt-28">
        <div className="w-full max-w-3xl">
          {/* Card */}
          <div
            dir={isRTL ? "rtl" : "ltr"}
            className="bg-card border border-border rounded-2xl shadow-sm overflow-hidden"
          >
            {/* Top accent bar */}
            <div className="h-1 bg-gradient-to-r from-primary via-secondary to-brand-green" />

            <div className="p-8 md:p-12">
              {/* Logo + heading */}
              <div className="flex flex-col items-center gap-3 mb-8">
                <Logo size="md" />
                <h1 className="text-xl md:text-2xl font-bold text-center text-foreground leading-snug">
                  <span className="bg-primary/10 text-primary px-2 py-0.5 rounded">
                    {t(locale, "initiativeRequestTitle")}
                  </span>
                </h1>
                <p className="text-sm text-foreground-secondary text-center leading-relaxed max-w-md">
                  {t(locale, "initiativeRequestSubtitle")}
                </p>
              </div>

              <InitiativeRequestForm />
            </div>
          </div>
        </div>
      </main>

      <SiteFooter />
      <ThemeToggle />
    </div>
  );
}
